export const OTS = {
    PROFILE_BRAND_NAME: "profile-brand-name",
    PROFILE_EDIT_MODE: "profile-edit-mode",
    PROFILE_EDIT_LINKS: "profile-edit-links",
    PROFILE_SAVE_LINKS: "profile-save-links",
    PROFILE_SELECT_LINESHEET: "profile-select-linesheet",
    PROFILE_REMOVE_LINESHEET: "profile-remove-linesheet",
    PROFILE_LINK_INSTAGRAM: "profile-link-instagram",
    PROFILE_ABOUT: "profile-about",
    PROFILE_SUBHEADING: "profile-subheading",
    PROFILE_ADMIN_REDIRECT: "profile-admin-redirect",
    PROFILE_VISIBLE_TO_BUYERS: "profile-visible-to-buyers",
    PROFILE_BACK_TO_BROWSE: "profile-back-to-browse",
};
